import { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { DatePicker } from "@shopify/polaris";

RHFDateRangePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
};

export default function RHFDateRangePicker({ name, label, ...other }) {
  const { control } = useFormContext();
  const today = new Date();
  const [{ month, year }, setDate] = useState({ month: today.getMonth(), year: today.getFullYear() });

  const handleMonthChange = useCallback((month, year) => setDate({ month, year }), []);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DatePicker
          month={month}
          year={year}
          onMonthChange={handleMonthChange}
          onChange={(value) => {
            field.onChange({
              from: value.start ? value.start : null,
              to: value.end ? value.end : null,
            });
          }}
          selected={
            field.value && field.value.from && field.value.to
              ? { start: field.value.from, end: field.value.to }
              : undefined
          }
          allowRange
          {...other}
        />
      )}
    />
  );
}
